// Which branches a user's branch-scoped screens may offer. Mirrors the backend:
// _scope_clinic_query (routes_clinic.py) for reports, _assert_own_branch
// (routes_consultation.py) for clinic settings, _check_branch_scope
// (routes_packages.py) for packages. Picking a branch outside these is a 403.

export const isHQ = (user) => ["super_admin", "hq_admin"].includes(user?.role);

/** The subset of `branches` this user works in. HQ: all of them. Franchisee
 * owner: their franchise's branches. Everyone else: their own branch_ids. */
export function ownBranches(user, branches) {
  const list = branches || [];
  if (isHQ(user)) return list;
  if (user?.role === "franchisee_owner") {
    return user.franchise_id ? list.filter((b) => b.franchise_id === user.franchise_id) : [];
  }
  const mine = user?.branch_ids || [];
  return list.filter((b) => mine.includes(b.id));
}

/** HQ manages every package; a branch manager / receptionist only one sold
 * EXCLUSIVELY at their own branches ([] = all branches stays HQ's). */
export function canManagePackage(user, pkg) {
  if (isHQ(user)) return true;
  const ids = pkg?.branch_ids || [];
  const mine = user?.branch_ids || [];
  return ids.length > 0 && ids.every((b) => mine.includes(b));
}
